import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        padding: 0,
        paddingTop: 0,
        width: '100%'
    },
    textfield: {
        width: '100%'
    }
}));